module.exports = __webpack_public_path__ + "img/volvo_tjrw.11b17a4f.svg";